type EnvVariables = {
  DMP_BASE_URL: string;
};

const env =
  (window as typeof window & { _env_: EnvVariables })._env_ ||
  ({
    DMP_BASE_URL: 'https://api-data-dev.centific.com',
  } as EnvVariables);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _app_meta_ = (window as any)._app_meta || {
  BUILD_TIME: 0,
};

export const envConfig = {
  dmpBaseUrl: env?.DMP_BASE_URL,
};

export const appMeta = {
  buildTime: Number(_app_meta_.BUILD_TIME),
};

export const getLatestBuildTime = async () => {
  try {
    const response = await fetch('/env-config.js');
    const text = await response.text();
    const match = text.match(/BUILD_TIME:\s*["'](.+?)["']/);
    if (match) {
      const buildTime = match[1];
      return Number(buildTime);
    }

    return 0;
  } catch {
    throw 'Fetch env-config.js failed';
  }
};
